import { TypographyColor } from 'melp-design/components';
import { AssignmentStatus } from 'store/assignments';
import { NewsStatus } from './news.types';

export const COLOR_BY_STATUS: Record<NewsStatus, TypographyColor> = {
  inactive: 'textSecondary',
  published: 'success',
  expiresSoon: 'warning',
  expired: 'textSecondary',
  comingSoon: 'warning',
  draft: 'textSecondary',
};

export const COLOR_BY_ASSIGNMENT_STATUS: Record<
  AssignmentStatus,
  TypographyColor
> = {
  on: 'success',
  off: 'textSecondary',
};

export const NONE_CATEGORY_ID = 'none';
